import validators from '@utils/validators';

const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.expiry_date, 'expiry_date'));

    const validateDomain = (domain, fieldName) => {
        Object.assign(errors, validators.maxLength({ value: domain, maxLength: 100 }, fieldName));
        Object.assign(errors, validators.protocolValidator(domain, fieldName));
    };

    if (values.domains) {
        validateDomain(values.domains, 'domains');
    }

    if (values.domains) {
        validateDomain(values.domains_edit, 'domains_edit');
    }

    return errors;
};

export default validate;
